const isEventValidForSubmit = (event) => {
    if (!event) return false;

    return !!event.sideSelected?.id;
};

export default isEventValidForSubmit;
